module.exports = "pegasus/assets/theme5/medium/1.jpg";